module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"missing_required_fields":"因未滿足條件，無法獲得回饋。"}}')
  delete Component.options._Ctor
}
